import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "converter-container"
};
const _hoisted_2 = {
  class: "converter-card"
};
const _hoisted_3 = {
  class: "tabs"
};
const _hoisted_4 = {
  class: "content"
};
const _hoisted_5 = {
  key: 0,
  class: "tab-content"
};
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<label for=\"csv-upload\" class=\"upload-label\"><div class=\"upload-icon\"><svg viewBox=\"0 0 24 24\" width=\"48\" height=\"48\"><path d=\"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z\" fill=\"currentColor\"></path></svg></div><p class=\"upload-text\">拖放CSV文件到这里或点击上传</p><p class=\"upload-hint\">支持 .csv 格式</p></label>", 1);
const _hoisted_7 = {
  key: 0,
  class: "result-section"
};
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, "转换结果", -1);
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z",
  fill: "currentColor"
})], -1);
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z",
  fill: "currentColor"
})], -1);
const _hoisted_11 = {
  class: "json-preview"
};
const _hoisted_12 = {
  key: 1,
  class: "tab-content"
};
const _hoisted_13 = {
  class: "input-area"
};
const _hoisted_14 = {
  class: "controls"
};
const _hoisted_15 = ["disabled"];
const _hoisted_16 = {
  key: 0,
  class: "error-message"
};
const _hoisted_17 = {
  key: 1,
  class: "preview-section"
};
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h3", null, "CSV预览", -1);
const _hoisted_19 = {
  class: "csv-preview"
};
import { ref, computed, onUnmounted } from 'vue';
import { saveAs } from 'file-saver';
import { parse as csvParse } from 'papaparse';
export default {
  __name: 'jsoncsv',
  setup(__props) {
    const activeTab = ref('csvToJson');
    const csvData = ref([]);
    const jsonInput = ref('');
    const csvFileUrl = ref('');
    const csvPreview = ref('');
    const conversionError = ref('');
    const isDragging = ref(false);
    const notification = ref({
      show: false,
      message: '',
      type: 'success'
    });

    // 格式化显示的JSON
    const formattedJson = computed(() => {
      return JSON.stringify(csvData.value, null, 2);
    });

    // 检查JSON是否有效
    const isValidJson = computed(() => {
      try {
        if (!jsonInput.value.trim()) return false;
        JSON.parse(jsonInput.value);
        return true;
      } catch {
        return false;
      }
    });

    // 处理CSV文件上传
    const handleCsvUpload = event => {
      const file = event.target.files[0];
      if (file) {
        processCsvFile(file);
      }
    };

    // 处理拖放
    const dragOver = () => {
      isDragging.value = true;
    };
    const handleDrop = event => {
      isDragging.value = false;
      const file = event.dataTransfer.files[0];
      if (file && file.name.endsWith('.csv')) {
        processCsvFile(file);
      } else {
        showNotification('请上传有效的CSV文件', 'error');
      }
    };

    // 处理CSV文件
    const processCsvFile = file => {
      const reader = new FileReader();
      reader.onload = e => {
        try {
          const csvString = e.target.result;
          // 使用PapaParse解析CSV
          csvParse(csvString, {
            header: true,
            skipEmptyLines: true,
            complete: results => {
              csvData.value = results.data;
              showNotification('CSV文件转换成功!', 'success');
            },
            error: error => {
              throw error;
            }
          });
        } catch (error) {
          console.error('Error processing CSV file:', error);
          showNotification('处理CSV文件时出错', 'error');
        }
      };
      reader.onerror = () => {
        showNotification('读取文件时出错', 'error');
      };
      reader.readAsText(file);
    };

    // 复制JSON到剪贴板
    const copyJson = () => {
      navigator.clipboard.writeText(formattedJson.value).then(() => showNotification('JSON已复制到剪贴板', 'success')).catch(() => showNotification('复制失败', 'error'));
    };

    // 下载JSON文件
    const downloadJson = () => {
      const blob = new Blob([formattedJson.value], {
        type: 'application/json'
      });
      saveAs(blob, 'data.json');
      showNotification('JSON文件下载开始', 'success');
    };

    // 将JSON转换为CSV
    const convertJsonToCsv = () => {
      try {
        const json = JSON.parse(jsonInput.value);
        if (!Array.isArray(json)) {
          throw new Error('JSON数据应该是一个数组');
        }

        // 生成CSV内容
        let csvContent = '';

        // 添加表头
        if (json.length > 0) {
          const headers = Object.keys(json[0]);
          csvContent += headers.join(',') + '\r\n';
        }

        // 添加数据行
        json.forEach(item => {
          const values = Object.values(item).map(value => {
            // 处理包含逗号或换行符的值
            if (typeof value === 'string' && (value.includes(',') || value.includes('\n'))) {
              return `"${value.replace(/"/g, '""')}"`;
            }
            return value;
          });
          csvContent += values.join(',') + '\r\n';
        });

        // 生成CSV预览
        csvPreview.value = csvContent;

        // 创建下载链接
        const blob = new Blob([csvContent], {
          type: 'text/csv;charset=utf-8;'
        });

        // 释放之前创建的URL
        if (csvFileUrl.value) {
          URL.revokeObjectURL(csvFileUrl.value);
        }
        csvFileUrl.value = URL.createObjectURL(blob);
        conversionError.value = '';
        showNotification('JSON转换成功! 点击下载CSV文件', 'success');
      } catch (error) {
        conversionError.value = `转换错误: ${error.message}`;
        showNotification('JSON转换失败', 'error');
      }
    };

    // 下载CSV文件
    const downloadCsv = () => {
      if (csvFileUrl.value) {
        saveAs(csvFileUrl.value, 'data.csv');
        showNotification('CSV文件下载开始', 'success');
      }
    };

    // 显示通知
    const showNotification = (message, type) => {
      notification.value = {
        show: true,
        message,
        type
      };
      setTimeout(() => {
        notification.value.show = false;
      }, 3000);
    };

    // 组件卸载时清理
    onUnmounted(() => {
      if (csvFileUrl.value) {
        URL.revokeObjectURL(csvFileUrl.value);
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("button", {
        class: _normalizeClass(["tab-button", {
          active: activeTab.value === 'csvToJson'
        }]),
        onClick: _cache[0] || (_cache[0] = $event => activeTab.value = 'csvToJson')
      }, " CSV转JSON ", 2), _createElementVNode("button", {
        class: _normalizeClass(["tab-button", {
          active: activeTab.value === 'jsonToCsv'
        }]),
        onClick: _cache[1] || (_cache[1] = $event => activeTab.value = 'jsonToCsv')
      }, " JSON转CSV ", 2)]), _createElementVNode("div", _hoisted_4, [activeTab.value === 'csvToJson' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", {
        class: "upload-area",
        onDragover: _withModifiers(dragOver, ["prevent"]),
        onDrop: _withModifiers(handleDrop, ["prevent"])
      }, [_createElementVNode("input", {
        type: "file",
        id: "csv-upload",
        accept: ".csv",
        onChange: handleCsvUpload,
        class: "file-input"
      }, null, 32), _hoisted_6], 32), csvData.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", {
        class: "result-header"
      }, [_hoisted_8, _createElementVNode("div", {
        class: "action-buttons"
      }, [_createElementVNode("button", {
        onClick: copyJson,
        class: "action-button"
      }, [_hoisted_9, _createTextVNode(" 复制JSON ")]), _createElementVNode("button", {
        onClick: downloadJson,
        class: "action-button"
      }, [_hoisted_10, _createTextVNode(" 下载JSON ")])])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("pre", null, _toDisplayString(formattedJson.value), 1)])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), activeTab.value === 'jsonToCsv' ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => jsonInput.value = $event),
        placeholder: "请输入有效的JSON数据，例如：[{name: '张三', age: 25}, {name: '李四', age: 30}]",
        class: "json-textarea"
      }, null, 512), [[_vModelText, jsonInput.value]])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("button", {
        onClick: convertJsonToCsv,
        disabled: !isValidJson.value,
        class: "convert-button"
      }, " 转换为CSV ", 8, _hoisted_15), csvFileUrl.value ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        onClick: downloadCsv,
        class: "download-button"
      }, " 下载CSV文件 ")) : _createCommentVNode("", true)]), conversionError.value ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(conversionError.value), 1)) : _createCommentVNode("", true), csvPreview.value ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_hoisted_18, _createElementVNode("div", _hoisted_19, [_createElementVNode("pre", null, _toDisplayString(csvPreview.value), 1)])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])]), notification.value.show ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["notification", notification.value.type])
      }, _toDisplayString(notification.value.message), 3)) : _createCommentVNode("", true)]);
    };
  }
};